/**
 * @copyright 2022 Nuance Communications Inc.
 * All Rights Reserved.
 */

import { DependencyList, useEffect, useRef } from "react";

/**
 * This is a customization of the useEffect hook which skips firing
 * on the initial rendering of the component. This will only fire when
 * any of the dependencies passed in via the deps argument have been
 * updated.
 */
export const skipInitialRenderEffect = (effect: () => void, deps?: DependencyList) => {
    const initialRender = useRef(true);
    useEffect(() => {
        if (initialRender.current) {
            initialRender.current = false;
        } else {
            effect();
        }
    }, deps);
};
